<template>
  <v-flex sm8 offset-sm2 id="loginRedirect">
    <i>We will log you in ... please wait.</i>
  </v-flex>
</template>

<script>
//Central config
import config from "../../configuration.json";

export default {
  data() {
    return {
      analyticsDataLayer: {
        site: "Shiftplan Landshut EP",
        name: "Login Callback",
        app_id: "com.schott.corporate.pwa.wfmplanner",
        app_name: "WFM Planner",
        uri: "/",
        pageType: "landingpage",
        isLoggedIn: this.$store.getters.profile != undefined,
        pageTags: ["wfm", "shiftplan", "hr"],
        targetGroup: "customers",
        businessUnit: "LP",
        websiteBusiness: "employeeProductivity",
        branded: "unbranded",
        stage: config.stage,
      },
    };
  },
  created() {
    //ANALYTICS
    let dl = this.analyticsDataLayer;
    dl["event_category"] = "screenview";
    dl["event_label"] = "Screen View / " + this.analyticsDataLayer.name;

    this.$parent.$appInsights.trackEvent(dl.event_label, dl);
    this.$parent.$appInsights.flush();
    this.$parent.$gtag.event(dl.event_label, dl);

    this.dispatchLogin();
  },
  methods: {
    dispatchLogin: async function () {
      let tokens = {
        token: this.getHashValue("id_token"),
      };

      await this.$store.dispatch("loginCallback", tokens);
      let route = "/";
      if (sessionStorage.getItem("originalRoute") != undefined) {
        route = sessionStorage.getItem("originalRoute");
        sessionStorage.removeItem("originalRoute");
      }
      this.$router.push(route);
    },
    getHashValue: function (key) {
      let matches = location.hash.match(new RegExp(key + "=([^&]*)"));
      return matches ? matches[1] : null;
    },
  },
};
</script>
